// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"78d0be7f","455":"f95f2063","977":"d8e66d4f"}[chunkId] + ".chunk.js";
};